import React from "react";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import Form from "react-bootstrap/Form";
import useChangeCheck from "./useChangeCheck";
import ChangeCheckContext from "../support/ChangeCheckContext";
import InputGroup from "react-bootstrap/InputGroup";

function RichTextInput(props) {

    const {onChange, getStyle} = useChangeCheck(props.onChange);
    const {disable} = React.useContext(ChangeCheckContext)

    function update(newValue) {
        onChange({target: {name: props.name, value: newValue}})
    }

    function customCustomStyle() {
        // Make the background color of the editor white when the editor is enabled
        if (!disable) {
            const defaultStyle = getStyle()
            if (!defaultStyle) {
                return {backgroundColor: '#ffffff'}
            }
        }
        return getStyle()
    }

    return (
        <>
            {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
            <div className="mb-3">
                <ReactQuill readOnly={disable} theme="snow" onChange={update} value={props.value} style={customCustomStyle()}/>
            </div>
        </>
    )
}

export default RichTextInput
